/* import __COLOCATED_TEMPLATE__ from './sh-payments-record-list.hbs'; */
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
 * This is the admin view for the sh-payments
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-sh-payments-record-list'],

  /**
   * Register services
   */
  applicationStateManager: service('state-managers/application'),
  state: service('states/routes/admin/accounting/payout'),
  stateManager: service('state-managers/routes/admin/accounting/payout'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}
   */
  _isShowPaginator: computed('state.currentPagination.total', function() {
    return this.get('state.currentPagination.total');
  }),

  /**
   * @type {Pagination}
   */
  _pagination: readOnly('state.currentPagination'),

  actions: {
    /**
     *
     */
    onAdvancePageBackward() {
      this.get('stateManager').loadPreviousPaymentsPage();
    },

    /**
     *
     */
    onAdvancePageForward() {
      this.get('stateManager').loadNextPaymentsPage();
    }
  }
});
